<template>
	<div class="answer-app">
		<!--nav-->
		<div class="detail-nav">
			<a @click="jumpList()">
				<img src="images/index.png" />首页
			</a>
			<a @click="jumpList()">{{tiname !==''?tiname:titename[indexs].index}}</a>
			<span>{{chapter_sub}}</span>
      <span>{{questionName}}</span>

		</div>

		<!-- answer -->
		<div class="answer-box">
					<div class="answer-box-left">
				<div class="answer-title">
					<p>
						<span>
							<i class="answer-titleinth">{{page}}</i>/
							<i>{{allNumber}}</i>
						</span>
					</p>
					<strong>
						<em>{{chapter_sub}}</em>
					</strong>
					<button class="answer-title-que" @click="showQueWin = true">答疑</button>
					<el-dialog :visible.sync="showQueWin" width="400px">
						<div class="win-que">
							<img src="/images/an_11.png" alt />
							<div>
								<img src="/images/qun.png" alt />
							</div>扫二维码加入答疑QQ群
						</div>
					</el-dialog>
					<button class="answer-title-wrong" @click="openWrongWin">纠错</button>
					<el-dialog :visible.sync="showWrongWin" width="480px">
						<div class="win-wrong">
							<h3>纠错</h3>
							<el-form ref="form">
								<el-form-item>
									<el-input type="textarea" v-model="wrongValue" placeholder="请输入纠错内容" maxlength="200"
										show-word-limit></el-input>
								</el-form-item>
								<el-button    type="primary" @click="errorCorrection(page-1)">确认</el-button>
							</el-form>
						</div>
					</el-dialog>
					<button class="answer-title-col" :class="{'col-active':     data.length>0    &&   data[page-1].collect===1}"
						@click="setCollect(page)">收藏</button>
				</div>

			<!-- <div class="answer-box-left">
				<div class="answer-title">
					<p>
						<span>
							<i>{{page}}</i>/
							<i>{{counts}}</i>
						</span>
					
					</p>
					<strong>
						<em>{{chapter_sub}}</em>
					</strong>
					<button class="answer-title-que" @click="showQueWin = true">答疑</button>
					<el-dialog :visible.sync="showQueWin" width="400px">
						<div class="win-que">
							<img src="/images/an_11.png" alt />
							<div>
								<img src="https://www.sz517.com/static/home/images/dyh.jpg" alt />
							</div>扫二维码加入答疑QQ群
						</div>
					</el-dialog>
					<button class="answer-title-wrong" @click="openWrongWin">纠错</button>
					<el-dialog :visible.sync="showWrongWin" width="480px">
						<div class="win-wrong">
							<h3>纠错</h3>
							<el-form>
								<el-form-item>
									<el-input type="textarea" v-model="wrongValue" placeholder="请输入纠错内容" maxlength="200"
										show-word-limit></el-input>
								</el-form-item>
								<el-button type="primary" @click="errorCorrection(page-1)">确认</el-button>
							</el-form>
						</div>
					</el-dialog>
					<button class="answer-title-col" :class="{'col-active': data[page-1].collect===1}"
						@click="setCollect(page)">收藏</button>
				</div> -->

				<!-- 题目 -->
				<!-- :key="value.id -->
				<div class="answer-que" v-show="key===page-1" v-for="(value,key) in data" :key="key"
					:class="{'answer-gap':fillInTheBlankQuestionType.includes(value.genre),'answer-title-img':value.icon,'answer-word':titleHeight >=121 && index == page-1}">
					<div class="answer-que-title">
						<xmp   :class="{'answer-que-title-xmp':isUnfold}" ref="xmpHeight">  <em class="titeling">{{data[page-1].genre_text}}</em>  {{value.title}}  </xmp>
						<div class="demo-image__preview" v-if="value.icon"  > 
							<el-image style="width: 100%; height: 100%" :src="value.icon"
							        	:preview-src-list="[value.icon]"> 
												
								</el-image>
						</div>
						<p @click="setTitleUnfold">{{setTitleText}}</p>
					</div>
					<div class="answer-que-option">
						<!-- 单选题 -->
						<p    :class="{right:answerTrueArray[page]==options,wrong:answersArray[page]=='null'? false:  answersArray[page]  == options}"    v-if="multipleChoiceQuestions.includes(value.genre)"
							v-for="(item,options) in value.option_name" :key="options" @click="multipleChoice(options,$event)"
						>
					
							<em>{{options}}</em>
								 
						 <xmp v-if="item.indexOf('http')==-1 && item!=='' " >{{item}}</xmp>
						  <xmp v-else> <img :src="item"  referrerpolicy="no-referrer"  >暂无选型</xmp> 
						</p>
							<p   v-show="multipleChoiceQuestions.includes(value.genre)" class="willnot"
							@click="multipleChoice(ns,$event,'h')" :class="{wrong:buhui[page]=='?'}">
							<em>?</em>
							<xmp>不会</xmp>
						</p>
				
						<!-- 单选题 -->
						<!-- 多选题 -->
					
						<p v-if="multipleChoicesQuestions.includes(value.genre)"
							v-for="(item,options) in value.option_name" :key="options" @click="multipleChoices($event)" 
							:class="{right:answerTrueArray[page]==options ||  ss[page]==null?false:ss[page].indexOf(options) !=-1?true:false    , codes: intersection[page]==null  ?false:intersection[page].indexOf(options)!=-1? true:false , wrong:  diff[page]==null?false:diff[page].toString().indexOf(options)!=-1? true:false            } "
					 > 
							<em>{{options}}</em>
							<xmp v-if="item.indexOf('http')==-1" >{{item}}</xmp>
						  <xmp v-else> <img :src="item"  referrerpolicy="no-referrer" alt=""></xmp> 
						</p>
							<p   v-if="multipleChoicesQuestions.includes(value.genre)" class="willnot"
							@click="multipleChoices($event)" :class="{wrong:answersArray[page]==='?'}">
							<em>?</em>
							<xmp>不会</xmp>
						</p>
						<!-- 多选题 -->
						<!-- 填空题 -->
						<p v-if="fillInTheBlankQuestionType.includes(value.genre)"
							v-for="(item,index) of (value.title.split('_____')).length - 1" :key="index">
							<em>{{index+1}}</em>
							<el-form :model="formOption">
								<el-form-item>
									<el-input v-model="formOption[index]" placeholder="请输入答案"></el-input>
								</el-form-item>
							</el-form>
						</p>
						<!-- 填空题 -->
						<!-- 简答题 -->
						<p v-show="shortAnswerQuestionType.includes(value.genre)" class="willnot"
							@click="meetingWillNot($event)" :class="{right:answersArray[page]==='会'}">
							<em>?</em>
							<xmp>会</xmp>
						</p>
						<!-- 简答题 -->
						<p v-show="shortAnswerQuestionType.includes(value.genre)" class="willnot"
							@click="meetingWillNot($event)" :class="{right:answersArray[page]==='不会'}">
							<em>?</em>
							<xmp>不会</xmp>
						</p>
					</div>
					<!-- 多选题start -->
					<div class="answer-que-option-btn" v-show="multipleChoicesQuestions.includes(value.genre)">
						<el-button  v-show="overs[page] !=true"  type="success" @click="multipleChoicesDetermine($event)">确认</el-button>
					</div>
					<!-- 多选题end -->
					<!-- 填空题start -->
					<div class="answer-que-option-btn" v-show="fillInTheBlankQuestionType.includes(value.genre)">
						<el-button type="success" @click="fillInTheBlank($event)">确认</el-button>
					</div>
					<!-- 填空题end -->
				</div>

				<div class="answer-que-btn answer-que-btn-noParsing"  >
					<el-button class="answer-prev" :class="{'el-button--primary':page!==1}" :disabled="page===1"
						@click="previousQuestion()"      >上一题</el-button>
					

					<el-button  style="margin-left:-150px"    v-if="page==count" class="el-button--primary answer-next" @click="nextQuestion()">提交
					</el-button>
					<el-button   style="margin-left:-150px"    v-else class="el-button--primary answer-next"    @click="nextQuestion()">下一题</el-button>
						<el-button   :class="{answerhove:anserwfont[page]==true}"          style=" border-color: #e60012;color: #e60012;"    @click="Parse()"  class="  el-button" >
							<img src="/images/an_4.png" />查看解析
						</el-button>
				</div>
			<div class="parsing" v-if="Parses[page]" >
						<div class="parsing-titles  dis"  >
								
								<span>
									正确答案：
									<em>  {{data[page-1].genre_text =='简答题'?"请查看解析":data[this.page-1].answer}}     </em>
									<!-- {{data[page-1].genre_text == '简答题'?"请查看解析":item.answer}}  -->
								</span>
								<span class="wrong">
									你的答案：
									<em>{{answersArray[this.page]=='?'?'不会':answersArray[this.page]=="n"?"不会":answersArray[this.page]=='j'?data[this.page-1].answer:answersArray[this.page]  }}</em>
									<!-- {{answerArray[page]}} -->
								</span>
							
							<div>
								全站正确率：<i style="color: #ff6c6c;font-style: normal;">{{data[this.page-1].right_rate}}%</i>
								<!-- {{item.right_rate}} -->
							</div>
						</div>
						<p class="pin">	<span> <span class="pinspan"></span> 知识点解析</span></p>
						<p  class="pins"   v-html="data[page-1].analysis"  ></p>
						<!-- v-html="item.analysis" -->
						<!-- {{item.analysis}} -->
						<p style="margin-top:30px;color:black"><span style="    display: inline-block; width: 5px; height: 15px;margin: 0px 5px 0px 11px;border-radius: 2px 2px 2px 2px; background-color: red;"></span><span style="font-size: 18px;font-family: Microsoft YaHei;font-weight: bold;color: #0c0101;">试题来源:</span> {{data[page-1].source_name}} </p>
					<!-- {{item.source_name}} -->
					</div>
          <!-- notes  -->
         	
          <Noters   
          :subid = sub_id    
          :notesList = data
          :page = page
          :Parses =  Parses  
          :notes= notes
           ref="Noters"
            >
          </Noters>


					</div>

		</div>

		<div class="answer-box-right">
			<!--时间 返回-->
			<div class="answer-time">
				<p>
					<img src="images/an_2.png" />
					<span>{{timeStr}}</span>
				</p>
				<a title="提交" @click="jumpList()">
					<img src="images/an_3.png" />
				</a>
			</div>

			<!--答题卡-->
			<div class="answer-card">
				<h3>
					<img src="images/an_7.png" /> 答题卡
				</h3>
				<div class="card card-a" style=" height: 300px !important;overflow-y: auto;">

					<el-button v-for="(item,kk) in parseInt(this.allNumber)" :key="kk"      :class="{right:cacheAnswer[kk] && cacheAnswer[kk]['res']==1,wrong:cacheAnswer[kk] && cacheAnswer[kk]['res']==0}"
						@click="Answersheet(item)">{{item}}</el-button>
				</div>
				<el-button type="primary" class="card-sub" @click="stopKeepTime">提交</el-button>
		
			</div>



			<!--相关推荐-->
			<div class="answer-recom">
				<h3>
					<img src="images/an_5.png" /> 相关推荐
				</h3>
				<dl v-for="item in book" :key="item.id">
					<a @click="jump(item.id)">
						<dt>
							<img :src="'https://www.sz517.com'+item.icon" />
						</dt>
						<dd>{{item.name}}</dd>
						<p>￥{{item.price}}</p>
					</a>
				</dl>
			</div>
		</div>



		<div class="clear"></div>

<el-dialog title="提示"  style="margin-top:22vh"   :visible.sync="centerDialogVisibles"
  width="25%"
  center>
  <span class="el-dialog__bodyspan">你要结束本次练习吗？</span>
  <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisiblesf">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisiblest" >确 定</el-button>
  </span>
</el-dialog>	



	</div>
	





</template>

<script>
import { mapMutations, mapState } from "vuex";
import test from "../../../public/css/test.css";
import $EventBus from "../../eventBus/eventBus";
import Noters from "../../components/notes.vue";
export default {
  name: "answer-app",
  components: { Noters },
  computed: {
    ...mapState({
      centerDialogVisibles: (state) => {
        return state.answerPastReal.centerDialogVisibles;
      },
    }),
  },
  data() {
    return {
      titename: [
        { index: "专项练习" },
        { index: "随机练习" },
        { index: "历年真题" },
        { index: "冲刺密卷" },
        { index: "公告模考" },
        { index: "考试估分" },
        { index: "模拟考试" },
        { index: "时事政治" },
      ],
      i: 2,
      bums: 0,
      nss: "ns",
      anserwfont: [],
      usernot: "",
      state: [],
      overs: [],
      diff: [],
      index: "",
      arr: [],
      noteValue: "",
      answerArray: "",
      indexs: localStorage.getItem("listName"),
      type: 3, //3历年整体4冲刺密卷
      page: 1,
      cuowu: [],
      count: 0,
      data: [],
      counts: this.$route.query.number,
      allNumber: 0,
      sub_id: 0,
      ques_id: 0,
      category_name: "",
      chapter: "",
      chapter_sub: "",
      answerTrueArray: [],
      book: [],
      maximum: 50,
      bus: 0,
      theSmallest: 1,
      cacheAnswer: [], //缓存答案
      answersArray: [],
      right: [],
      imges: "",
      answerOption: ["A", "B", "C", "D", "E", "F", "G"],
      multipleChoiceQuestions: [
        0, 1, 3, 4, 5, 7, 8, 9, 1001, 1003, 1004, 1101, 1104, 1201, 1301, 1304,
      ], //单选题题型
      multipleChoicesQuestions: [2, 1002, 1102, 1302], //多选题题型
      fillInTheBlankQuestionType: [6, 1206], //填空题题型
      shortAnswerQuestionType: [4, 5, 7, 8, 9, 1004, 1104, 1304], //简答题题型
      titleSrcList: [],
      btnDisabled: true, //禁用prev  next按钮
      noteValue: "", //笔记文本框
      wrongValue: "", //纠错文本框
      cardSelect: [],
      selectedValue: "1",
      formOption: {},
      isUnfold: false, //是否展开
      setTitleText: "展开文章",
      showQueWin: false,
      showWrongWin: false,
      h: 0,
      m: 0,
      s: 0,
      pag: 1,
      times: "",
      timeStr: "",
      timer: null,
      praiseActive: false,
      scroll: "",
      titleHeight: "",
      pagene: "",
      zhuId: "",
      typeId: "",
      mock_id: "",
      navList: "",
      num: 1,
      ns: [],
      ss: [],
      intersection: [],
      buhui: [],
      inse: [],
      answersArrays: [],
      Parses: [],
      notes: "",
      userid: "",
      uid: "",
      bum: 1,
      ansr: [],
      titlename: "",
      tiname: "",
      questionName: "",
    };
  },
  created() {
    //console.log(this.$route)

    this.userid = localStorage.getItem("userId");
    this.$loading(true);
    this.sub_id = this.$route.query.quesId;
    this.ques_id = this.$route.query.quesId;
    this.type = this.$route.query.type;
    this.zhuId = this.$route.query.zhuId;
    this.typeId = this.$route.query.typeId;
    this.allNumber = this.$route.query.number;
    this.questionName = this.$route.query.name;
    this.getInitialData(this.$route.query.number);
    this.tiname =
      this.$route.query.tiname !== undefined ? this.$route.query.tiname : "";
    // this.titlename= this.$route.query.statenum !==undefined?this.$route.query.statenum:''
    if (this.tiname !== "") {
      let arrs = JSON.parse(localStorage.getItem(`${this.ques_id}`));
      //console.log(JSON.parse(localStorage.getItem(`${this.ques_id}`)) )
      this.answersArray = arrs[0];

      this.answerTrueArray = arrs[1];
      this.ss = arrs[2];
      this.intersection = arrs[3];
      this.cacheAnswer = arrs[4];
    }

    this.getInitialDatas();
    if (localStorage.getItem(this.sub_id) != null) {
      // //console.log(JSON.stringify(localStorage.getItem(this.sub_id)));

      this.cacheAnswerRecords();
    }
    console.log(this.bums);
    if (this.bums === 0) {
      console.log(this.bums);
      clearInterval(this.times);
    }
  },
  // 页面被销毁前执行打得方法
  beforeDestroy() {
    clearInterval(this.times);
    this.listenPage == null;

    // localStorage.setItem('answersArray', JSON.stringify(this.answerTrueArray))
    // localStorage.setItem('ss', JSON.stringify(this.ss))
    // localStorage.setItem('intersection', JSON.stringify(this.intersection))
    // localStorage.setItem('cacheAnswer', JSON.stringify(this.cacheAnswer))
  },
  destroyed() {
    window.removeEventListener("popstate", this.goIndex, false);
  },

  mounted() {
    window.onbeforeunload = function (e) {
      e = e || window.event;
      // 兼容IE8和Firefox 4之前的版本
      if (e) {
        e.returnValue = "您是否确认离开此页面-您输入的数据可能不会被保存";
      }
      // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
      return "您是否确认离开此页面-您输入的数据可能不会被保11存";
    };

    //使用addEventListener
    window.addEventListener("beforeunload", (e) => {
      this.beforeunloadHandler(e);
    });
    this.listenPage();
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goIndex, false);
    }
  },
  methods: {
    // tools(n){
    // 	 let  textn = n.slice(0,3)
    // 	 let sss =textn.split()
    // 		console.log(sss.includes("\."))
    // 		console.log(textn.split().indexOf("\."))

    // 	 if(textn.split().includes('\.')){
    // 		 		let subscript = n.indexOf('\.')
    // 				n = n.slice(subscript)
    // 	 }

    // 		  let textarr =  n.split()
    // 	 	  textarr.unshift(`${this.page}.`)
    // 			n = textarr.join('')
    // 	return 	 n
    // },
    goIndex() {
      //console.log("点击了")
      this.$router.replace({
        path: "/",
      });
    },

    // 离开页面取消
    centerDialogVisiblesf() {
      this.$store.commit("getli", false);
    },
    // 离开页面确定
    centerDialogVisiblest() {
      this.ansr = [
        this.answersArray,
        this.answerTrueArray,
        this.ss,
        this.intersection,
        this.cacheAnswer,
      ];
      localStorage.setItem(`${this.ques_id}`, JSON.stringify(this.ansr));
      $EventBus.$emit("mianname", { num: this.nss });
      this.$store.commit("getli", false);
      this.$router.push("/");
    },
    //点赞笔记
    praiseNotes(e, id) {
      //console.log(id)
      this.$api.userNotePraise({ id: id }).then((res) => {
        this.getbiji(id, "u");
      });
    },
    listenPage() {
      if (this.$route.name == "AnswerPastReal") {
        window.onbeforeunload = function (e) {
          e = e || window.event;
          if (e) {
            e.returnValue = "关闭提示";
          }
          return "关闭提示";
        };
      }
    },

    // 查看解析
    Parse() {
      this.Parses[this.page] = true;
      this.anserwfont[this.page] = true;
      console.log(this.Parses);
      console.log(this.$refs,"1")
      this.$refs.Noters.setParses()
      // this.getbiji(this.data[this.page-1].id);
    },
    getbiji(id, i) {
      if (i !== "u") {
        this.uid = id;
        //console.log(this.uid)
      } else {
        id = this.uid;
      }
      //console.log(id)
      this.$api
        .getPageNote({
          list_id: id,
        })
        .then((res) => {
          //console.log(id)
          //console.log(res)
          this.notes = res.data;
          var that = this;
          for (let v of res.data) {
            //console.log(v)
            if (v.user_id == that.userid) {
              //console.log("进入了")
              that.usernot = v.content;
            }
            let sum = parseInt(v.content.replace(/\s*/g, "").length / 54);
            let number = v.content.indexOf("\n");
            //console.log(number)
            if (v.content.length > 54) {
              if (number != -1) {
                return;
              }
              for (let i = 1; i <= sum; i++) {
                let nm =
                  v.content.slice(0, 54 * i) + "\n" + v.content.slice(54 * i);
                v.content = nm;
              }
            }
          }
        });
    },

    //保存笔记
    addnote(id) {
      //console.log(this.usernot)
      if (
        this.noteValue.trim() == "" ||
        this.noteValue.trim() == this.usernot
      ) {
        this.$message({
          type: "error",
          message:
            this.noteValue.trim() == ""
              ? "笔记不能为空！"
              : "两次笔记不能一样哦",
          showClose: true,
        });
        return;
      }
      this.$api
        .setUserNote({
          list_id: id,
          sub_id: this.sub_id,
          content: this.noteValue,
          type: 3,
        })
        .then((res) => {
          // //console.log(res);
          this.$message.success("笔记添加成功");
          this.noteValue = "";
          //console.log(id)
          this.Parse();
        });
    },

    jumpList() {
      // this.$confirm("您确定要离开当前页面吗？", "提示", {
      // 		confirmButtonText: "确定",
      // 		cancelButtonText: "取消",
      // 		type: "warning",
      // 	})
      // 	.then(() => {
      this.$router.push({
        path: "/",
      });
      // })
      // .catch(() => {});
    },
    //删除笔记
    deleteNote(id_, id) {
      this.$confirm("您确定要删除笔记吗？?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.delUserNote({ id: id_ }).then((res) => {
            this.Parse();
          });
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });

      // this.$confirm("您确定要删除笔记吗？", "删除", {
      // 		confirmButtonText: "确定",
      // 		cancelButtonText: "取消",
      // 		type: "warning",
      // 	})
      // 	.then(() => {
      // 		return
      // 		this.$post("deletenote", {
      // 			id: id_,
      // 		}).then((res) => {
      // 			if (res.code === 200) {
      // 				this.getInitialData();
      // 				this.$message({
      // 					type: "success",
      // 					message: "request succeeded！",
      // 					showClose: true,
      // 				});
      // 			} else {
      // 				this.$message({
      // 					type: "error",
      // 					message: "request failed！please try again later",
      // 					showClose: true,
      // 				});
      // 			}
      // 		});
      // 	})
      // 	.catch(() => {});
    },

    //提交试卷
    stopKeepTime() {
      this.state == "";
      for (let i = 0; i < this.count - 1; i++) {
        if (this.cacheAnswer[i] == "" || this.cacheAnswer[i] == null) {
          this.state[i] = "faelse";
        } else {
          this.state[i] = "";
        }
      }

      //console.log( this.count)
      //console.log(this.cacheAnswer)
      //console.log(this.state)

      if (this.cacheAnswer == undefined || this.state.includes("faelse")) {
        this.$message({
          type: "success",
          message:
            this.cacheAnswer == undefined ? "不能交白卷哟！" : "还有题未作答哦",
          showClose: true,
        });
        return;
      }
      this.stopTime();
      this.$confirm("您确定要结束答题吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$loading(true);
          console.log(this.cacheAnswer);
          for (var i = 0; i < this.count; i++) {
            if (!this.cacheAnswer[i]) {
              this.cacheAnswer[i] = {};
              this.cacheAnswer[i]["id"] = this.data[i].id;
              this.cacheAnswer[i]["text"] = this.data[i].text;
              this.cacheAnswer[i]["title"] = this.data[i].title;
              this.cacheAnswer[i]["score"] = this.data[i].score;
              this.cacheAnswer[i]["pid"] = this.data[i].pid;
              this.cacheAnswer[i]["genre"] = this.data[i].genre;
              this.cacheAnswer[i]["analysis"] = this.data[i].analysis;
              this.cacheAnswer[i]["option"] = this.data[i].option;
              this.cacheAnswer[i]["icon"] = this.data[i].icon;
              this.cacheAnswer[i]["genre_type"] = this.data[i].name;
              this.cacheAnswer[i]["user_answer"] = "未作答";
              this.cacheAnswer[i]["answer"] = this.data[i].answer;
              this.cacheAnswer[i]["res"] = 0;
            }
          }
          // return
          //console.log(this.cacheAnswer)
          for (let item of this.cacheAnswer) {
            if (item.answer == "未作答") {
              item.is_right = 3;
            } else if (item.answer == "不会") {
              item.is_right = 3;
            } else if (item.answer == item.user_answer) {
              item.is_right = 1;
            } else if (item.answer !== item.user_answer) {
              item.is_right = 2;
            }
          }

          let types;
          if (this.type == 1) {
            types = 3;
          } else if (this.type == 2) {
            types = 4;
          } else if (this.type == 3) {
            types = 7;
          } else if (this.type == 4) {
            types = 6;
          } else if (this.type == 5) {
            types = 5;
          } else if (this.type == 6) {
            types = 9;
          }

          var param = {
            time: this.h * 60 * 60 + this.m * 60 + this.s,
            ques_id: this.ques_id,
            data: this.cacheAnswer,
            type: types,
            sub_id: this.sub_id,
            main_id: this.zhuId,
            mock_id: this.mock_id,
          };

          this.$api.submitAnswer(param).then((res) => {
            this.$loading().close();
            // return
            // localStorage.removeItem(this.ques_id);
            // localStorage.removeItem(this.ques_id + 'time');
            this.$router.push({
              path: "/results",
              query: {
                result_id: res.data.result_id,
                type: types,
                ques_id: this.ques_id,
              },
            });

            //console.log(res)
          });

          return;
          this.$post("submitTestPaper", param).then((res) => {
            this.$loading().close();
            //console.log(res);
            if (res.id) {
              this.$post("setUserLog", {
                result_id: res.id,
              }).then((res) => {});
              localStorage.removeItem(this.sub_id);
              localStorage.removeItem(this.sub_id + "time");
              this.$router.push({
                path: "/results",
                query: {
                  result_id: res.id,
                  sub_id: this.sub_id,
                  ques_id: this.ques_id,
                },
              });
            } else {
              this.$message({
                type: "error",
                message: "request failed!please try again later",
                showClose: true,
              });
            }
          });
        })
        .catch(() => {
          this.startTime();
        });
    },
    //获取初始数据
    ...mapMutations(["setpage"]),
    getInitialData(nunm) {
      this.index = this.$route.query.index;
      this.pagene = this.pag;

      var param = {
        ques_id: this.ques_id,
        page: this.pagene,
        limit: 20,
      };
      this.$api.getQuesExam(param).then((res) => {
        //console.log(res)
        this.$loading().close();
        this.data = res.data.exam;
        this.navList = res.data.name;
        this.startTime();
        //console.log(res.data.exam)

        this.count = res.data.exam.length;
        //console.log(this.count)
        this.$forceUpdate();
      });
      // this.$post("getques", param).then((res) => {
      // 	this.$loading().close();
      // 	this.startTime();
      // 	// //console.log(res);
      // 	this.data = res.data;
      // 	this.count = res.data.length;
      // });
    },
    getInitialDatas() {
      var that = this;

      this.bum = Math.ceil(that.allNumber / 20);

      this.bums = this.bum;

      // let index = this.$route.query.index
      this.times = setInterval(function () {
        that.pagene = that.pageess;
        var param = {
          ques_id: that.ques_id,
          page: that.i,
          limit: 20,
        };
        //console.log(that.i)
        that.$api.getQuesExam(param).then((res) => {
          //console.log(res)
          that.data = [...that.data, ...res.data.exam];
          //console.log(	that.data)
          let numb = that.data.length - that.allNumber;
          that.count = numb < 0 ? that.data.length : that.data.length - numb;
        });
        console.log(that.i);
        console.log(that.bums);

        that.i++;
        that.bums--;
        // console.log(that.bum)

        console.log(that.bums);
      }, 1000);

      // this.$post("getques", param).then((res) => {
      // 	this.$loading().close();
      // 	this.startTime();
      // 	// //console.log(res);
      // 	this.data = res.data;
      // 	this.count = res.data.length;
      // });
    },

    //保存答案
    saveAnswer(answer_) {
      console.log(answer_);
      var page = this.page - 1;
      this.cacheAnswer[page] = {};
      this.cacheAnswer[page]["id"] = this.data[page].id;
      this.cacheAnswer[page]["text"] = this.data[page].text;
      this.cacheAnswer[page]["title"] = this.data[page].title;
      this.cacheAnswer[page]["score"] = this.data[page].score;
      this.cacheAnswer[page]["pid"] = this.data[page].pid;
      this.cacheAnswer[page]["genre"] = this.data[page].genre;
      this.cacheAnswer[page]["analysis"] = this.data[page].analysis;
      this.cacheAnswer[page]["option"] = this.data[page].option;
      this.cacheAnswer[page]["icon"] = this.data[page].icon;
      this.cacheAnswer[page]["genre_type"] = this.data[page].name;
      this.cacheAnswer[page]["user_answer"] = answer_;
      this.cacheAnswer[page]["answer"] = this.data[page].answer;
      if (answer_ === this.data[page].answer || answer_ === "会") {
        this.cacheAnswer[page]["res"] = 1;
      } else {
        this.cacheAnswer[page]["res"] = 0;
      }
      localStorage.setItem(this.ques_id, JSON.stringify(this.cacheAnswer));
      //保存答题时间
      //console.log(this.timeStr)
      localStorage.setItem(this.ques_id + "time", this.timeStr);
      console.log(this.cacheAnswer, "cacheAnswer");
    },
    //单选题
    multipleChoice(heidn, e, h) {
      if (this.answersArray[this.page]) {
        return;
      }
      //console.log(heidn,e)

      var that = e.currentTarget;
      $(that).addClass("right");
      $(that).siblings().removeClass("right");
      var answer = $(that).children("em").text();
      //console.log(answer)
      if (answer === "?") {
        this.buhui[this.page] = answer;
      }
      //console.log(this.page)

      this.answersArray[this.page] = heidn;
      this.answersArrays[this.page] = heidn;
      //console.log( "选择:",heidn)
      this.answerTrueArray[this.page] = this.data[this.page - 1].answer;
      //console.log( "选择:",heidn)
      //console.log(this.page)
      //console.log( "答案:", this.data[this.page-1].answer)
      //console.log(this.data)
      //console.log(h)
      if (this.data[this.page - 1].answer.indexOf(heidn) != -1 && h !== "h") {
        //console.log("1111111")
        this.answersArray[this.page] = "j";
        this.saveAnswer(answer);
        this.nextQuestion();
        return;
      }
      if (h == "h") {
        this.answersArray[this.page] = "n";
        this.saveAnswer("不会");
      } else {
        this.saveAnswer(answer);
      }
      this.Parse();
    },
    //多选题
    multipleChoices(e) {
      //console.log(this.inse[this.page] )
      if (this.inse[this.page] == 1) {
        return;
      }
      //console.log(e)
      var that = e.currentTarget;
      console.log(that);
      $(that).toggleClass("right");
      var answer = $(that).parent().children("p.right").children("em").text();
      var dd = "";
      for (var i = 0; i < answer.split("").length; i++) {
        dd += answer.split("")[i] + ",";
      }
      console.log(dd);
      dd = dd.substring(0, dd.lastIndexOf(","));
      //console.log("选项"+dd)
      //console.log( "答案:"+ this.data[this.page-1].answer)
      // 选中答案
      this.answersArray[this.page] = dd;

      // //console.log(dd)
    },
    //多选题确定
    multipleChoicesDetermine(e) {
      if (!this.answersArray[this.page]) {
        this.$message({
          type: "error",
          message: "请先选择答案",
          showClose: true,
        });
        return;
      }
      this.inse[this.page] = 1;
      this.overs[this.page] = true;
      //console.log(this.answersArray[this.page])
      //console.log(this.data)

      this.answerTrueArray[this.page] = this.data[this.page - 1].answer;
      console.log(this.answerTrueArray[this.page]);
      console.log(this.answersArray[this.page]);
      this.ns[this.page] = this.answersArray[this.page].split(",");
      this.ss[this.page] = this.answerTrueArray[this.page].split(",");

      //console.log(this.ns[this.page])
      //console.log(this.ss)
      this.cuowu[this.page] = this.ns[this.page].toString();
      var that = this;
      //console.log(that)
      let bSet = new Set(that.ss[that.page]);
      if (this.ns.toString() == this.ss.toString()) {
        //console.log("为零")
        this.saveAnswer(this.answersArray[this.page]);
        this.intersection[this.page] = "null";
        this.nextQuestion();
      } else {
        this.intersection[this.page] = Array.from(
          new Set(this.ns[this.page].filter((v) => bSet.has(v)))
        ).toString();
        this.diff[this.page] = this.ns[this.page].filter(function (val) {
          return that.intersection[that.page].indexOf(val) === -1;
        });

        if (this.ns.toString() == "?") {
          this.saveAnswer("不会");
        } else {
          this.saveAnswer(this.ns[this.page].toString());
        }

        this.Parse();
      }

      //console.log(this.intersection[this.page])
      //console.log(this.ns)
      //console.log(this.ss)
      //console.log(this.ns.toString()==this.ss.toString())
    },

    // 页面跳转提示
    centerDialogVisibleture() {},
    //填空题
    fillInTheBlank() {
      if (JSON.stringify(this.formOption) == "{}") {
        this.$message({
          type: "error",
          message: "请先填写答案",
          showClose: true,
        });
        return;
      }

      var num = this.data[this.page - 1].title.split("_____").length - 1;
      if (num > 1) {
        //多空填空题
        var tk = "";
        for (var i = 0; i < num; i++) {
          if (this.formOption[i]) {
            tk = tk + this.formOption[i] + ",";
          } else {
            tk = tk + "未作答" + ",";
          }
        }
        tk = tk.substring(0, tk.lastIndexOf(","));
        // //console.log(tk)
        this.saveAnswer(tk);
        this.answersArray[this.page] = tk;
      } else {
        this.saveAnswer(this.formOption[0]);
        this.answersArray[this.page] = this.formOption[0];
      }
      this.nextQuestion();
    },
    //会和不会
    meetingWillNot(e) {
      var that = e.currentTarget;
      $(that).addClass("right");
      $(that).siblings().removeClass("right");
      var answer = $(that).children("xmp").text();
      this.answersArray[this.page] = answer;
      //多空填空题start
      var num = this.data[this.page - 1].title.split("_____").length - 1;
      if (num > 1) {
        //多空填空题
        var tk = "";
        for (var i = 0; i < num; i++) {
          tk = tk + "不会" + ",";
        }
        answer = tk.substring(0, tk.lastIndexOf(","));
      }
      //多空填空题end
      this.saveAnswer(answer);
      this.nextQuestion();
    },
    //下一题
    nextQuestion() {
      if (this.page === this.count) {
        //最后一题
        this.stopKeepTime();
      } else {
        //console.log(this.page)
        this.page++;
        this.setHeight();
        this.publicFunction();
      }
    },
    publicFunction() {
      if (this.answersArray[this.page]) {
        if (
          this.multipleChoicesQuestions.includes(this.data[this.page - 1].genre)
        ) {
          this.right = this.answersArray[this.page].split(",");
        } else if (
          this.fillInTheBlankQuestionType.includes(
            this.data[this.page - 1].genre
          )
        ) {
          var num = this.answersArray[this.page].split(",");
          // //console.log(num);
          for (var i = 0; i < num.length; i++) {
            this.formOption[i] = num[i];
          }
        }
      } else {
        this.right = [];
        this.formOption = {};
      }
    },
    //上一题
    previousQuestion() {
      this.page--;
      this.setHeight();
      this.publicFunction();
    },
    setHeight() {
      this.titleHeight = this.$refs["xmpHeight"][this.page - 1].offsetHeight;
    },
    //点击序号跳转
    Answersheet(index_) {
      this.page = index_;
      this.publicFunction();
    },
    // 展开文章
    setTitleUnfold() {
      if (this.isUnfold) {
        this.isUnfold = false;
        this.setTitleText = "展开文章";
      } else {
        this.isUnfold = true;
        this.setTitleText = "收起文章";
      }
    },
    //纠错
    openWrongWin() {
      this.showWrongWin = true;
    },
    //纠错
    errorCorrection(id_) {
      if (this.wrongValue.trim() == "") {
        this.$message.error("请勿提交空白");
        return;
      }

      this.$api
        .setCorrection({ list_id: id_, content: this.wrongValue })
        .then((res) => {
          this.$message.success(
            "提交成功！感谢你的反馈，我们会在第一时间处理你的意见"
          );
        });
      this.showWrongWin = false;
    },

    //收藏
    setCollect(page) {
      let index = page - 1;

      this.$api
        .setUserCollect({
          list_id: this.data[index].id,
          sub_id: this.ques_id,
          type: 3,
        })
        .then((res) => {
          if (this.data[index].collect == 0) {
            this.$message.success("收藏试题成功");
            this.data[index].collect = 1;
          } else {
            this.$message.success("取消收藏成功");
            this.data[index].collect = 0;
          }
        });

      return;

      var dd = this.data[this.page - 1].favorite;
      if (dd === 0) {
        var param = {
          uid: this.user_id,
          tid: 4,
          gid: this.data[this.page - 1].id,
          sub_id: this.sub_id,
          answer_id: this.ques_id,
          create_time: Date.parse(new Date()) / 1000,
          update_time: Date.parse(new Date()) / 1000,
        };
        this.$post("addfavorite", param).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "收藏成功!",
              showClose: true,
            });
          }
        });
        this.data[this.page - 1].favorite = 1;
      } else {
        //收藏过
        this.$confirm("是否要取消收藏？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            //点击确定
            var param = {
              uid: this.user_id,
              qid: this.data[this.page - 1].id,
            };
            this.$post("deletefavorite", param).then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                  showClose: true,
                });
                this.data[this.page - 1].favorite = 0;
              } else {
                this.$message({
                  type: "success",
                  message: "删除失败，请稍后重试!",
                  showClose: true,
                });
              }
            });
          })
          .catch(() => {});
      }
    },
    //删除笔记
    deteNote() {
      this.$confirm("您确定要删除笔记吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功",
          });
        })
        .catch(() => {});
    },
    //点赞笔记
    praiseNote(e) {
      var that = e.currentTarget;
      $(that).toggleClass("note-list-active");
    },
    keepTime() {
      //定义计时函数
      this.s = this.s * 1 + 1;
      if (this.s >= 60) {
        this.s = 0;
        this.m = this.m * 1 + 1; //分钟
      }
      if (this.m >= 60) {
        this.m = 0;
        this.h = this.h * 1 + 1; //小时
      }
      // //console.log(this.timeStr)
      this.timeStr =
        this.toDub(this.h) +
        ":" +
        this.toDub(this.m) +
        ":" +
        this.toDub(this.s);
    },
    resetTime() {
      //重置
      clearInterval(this.time);
      this.h = 0;
      this.m = 0;
      this.ms = 0;
      this.s = 0;
      this.timeStr = "00:00:00";
    },
    startTime() {
      //开始
      this.timer = setInterval(this.keepTime, 1000);
    },
    stopTime() {
      //暂停
      clearInterval(this.timer);
    },
    toDub(n) {
      //补0操作
      if (
        n == "0" ||
        n == "1" ||
        n == "2" ||
        n == "3" ||
        n == "4" ||
        n == "5" ||
        n == "6" ||
        n == "7" ||
        n == "8" ||
        n == "9"
      ) {
        return "0" + n;
      } else {
        return "" + n;
      }
    },
    //顶部面包屑
    // cateCrumbs() {
    // 	var param = {
    // 		sub_id: this.sub_id
    // 	};
    // 	this.$post("cateCrumbs", param).then((res) => {
    // 		// //console.log(res);
    // 		this.path = res.data.city + '-' + res.data.path;
    // 		this.category_name = res.data.nname;
    // 		this.chapter = res.data.cname;
    // 		this.chapter_sub = res.data.name;
    // 		this.ques_id = res.data.ques_id;
    // 	});
    // },
    //获取题数数组
    // questionsCount() {
    // 	var param = {
    // 		qid: this.ques_id
    // 	};
    // 	this.$post("questionsCount", param).then((res) => {
    // 		// //console.log(res);
    // 		this.cardSelect = res.data;
    // 	});
    // },
    quescount(e) {
      var that = this;
      that.maximum = that.cardSelect[e].max;
      that.theSmallest = that.cardSelect[e].min;
    },
    //获取相关图书
    recommendationRelated() {
      var param = {
        sid: this.sub_id,
        city: localStorage.getItem("indexRegionId"),
      };
      this.$post("recommendationRelated", param).then((res) => {
        this.book = res.data;
      });
    },
    cacheAnswerRecords() {
      var that = this;
      var time = localStorage.getItem(this.sub_id + "time");
      //console.log(time)
      var str = time.split(":");
      this.h = str[0];
      this.m = str[1];
      this.s = str[2];
      this.cacheAnswer = JSON.parse(localStorage.getItem(this.sub_id));
      this.cacheAnswer.forEach(function (item, index) {
        if (item) {
          that.answersArray[index + 1] = item.user_answer;
        }
      });
    },
  },

  watch: {
    // ques_id: function() {
    // 	this.$nextTick(() => {
    // 		this.getInitialData();
    // 		this.questionsCount();
    // 		this.recommendationRelated();
    // 	});
    // },
    bums(vol, old) {
      console.log(vol);
      if (vol == 1) {
        console.log("判断");
        clearInterval(this.times);
      }
    },
    $route: {
      handler: function (val, oldVal) {
        this.stopTime();
      },
    },

    i(newname, oldname) {
      //console.log(this.bum,"监视")
      if (newname == this.bum) {
        clearInterval(this.time);
      }
    },
    sub_id: function () {
      this.$nextTick(() => {
        // this.cateCrumbs();
      });
    },
    data() {
      this.$nextTick(() => {
        this.setHeight();
      });
    },
    page() {
      this.$nextTick(() => {
        this.setHeight();
        this.isUnfold = false;
        this.setTitleText = "展开文章";
      });
    },
  },
};
</script>

<style>
.el-dialog {
  border-radius: 10px !important;
}
.el-dialog__bodyspan {
  text-align: center;
  display: inline-block;
  width: 100% !important;
  padding: 40px 0 40px 0;
  font-size: 22px;
}
.el-button--default {
  margin-right: 20px !important;
}
</style>
